import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { FormGroup, FormLabel, Stack } from '@mui/material';
import CustomButton from 'common/components/CustomButton';
import CustomIconButton from 'common/components/CustomIconButton';
import CustomTooltip from 'common/components/CustomTooltip';
import EmptyTypes from 'common/enums/emptyTypes';
import EmptyView from 'common/features/noData/EmptyView';
import useFlexBoxStyles from 'common/flexBox';
import useOnliveStyles from 'common/onliveStyles';
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import AppointmentFormActorForm from './AppointmentFormActorForm';

const AppointmentFormActors = (props) => {
    const { actors, setActors } = props;
    const { classes: flexBox, cx } = useFlexBoxStyles();
    const { classes: onlive } = useOnliveStyles();

    const [actorIdx, setActorIdx] = useState(-1);
    const [openForm, setOpenForm] = useState(false);
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();

    // if (!formConfig) {
    //     return null;
    // }

    const handleAddActorSubmit = ({ data, onSuccess, onFailure }) => {
        const isDuplicate = actors?.some((actor, index) => actor.email === data.email && index !== actorIdx);
        if (isDuplicate) {
            enqueueSnackbar(t('app.common.errorSameEmail'), { variant: 'error' });
            return;
        }
        if (actorIdx === -1) {
            setActors([...actors, { ...data }]);
        } else {
            setActors([...actors.slice(0, actorIdx), { ...data }, ...actors.slice(actorIdx + 1)]);
            setActorIdx(-1);
        }
        // onSuccess();
        setOpenForm(false);
    };

    const onDelete = (data) => {
        const index = 0;
        if (index >= 0 && index < actors.length) {
            setActors([...actors.slice(0, index), ...actors.slice(index + 1, actors.length)]);
        }
    };

    const onCancel = () => {
        setOpenForm(false);
        setActorIdx(-1);
    };

    const onEdit = (idx) => {
        setActorIdx(idx);
        setOpenForm(true);
    };

    const addActor = (
        <CustomButton variant="contained" color="primary" onClick={() => setOpenForm(true)}>
            <span>{t('event.eventFormActors.add')}</span>
        </CustomButton>
    );

    return (
        <FormGroup>
            <FormLabel>{t('iCallendar.appointmenForm.invites')}</FormLabel>
            {actors.length ? (
                <Stack
                    direction="column"
                    spacing={1}
                    className={cx(flexBox.w100, flexBox.paddingTop2, flexBox.paddingBottom2)}
                >
                    {actors.map((actor, index) => (
                        <Stack
                            direction="column"
                            className={cx(
                                flexBox.relative,
                                flexBox.padding21,
                                onlive.borderSecondaryDark,
                                flexBox.borderRadius1,
                                flexBox.relative,
                            )}
                        >
                            <Stack
                                direction="row"
                                justifyContent="flex-end"
                                alignItems="center"
                                className={cx(flexBox.absolute, flexBox.right1, flexBox.top1)}
                                spacing={1}
                            >
                                <CustomTooltip arrow title={t('actions.edit')} placement="bottom">
                                    <CustomIconButton
                                        id="onlive-button-edit"
                                        size="small"
                                        onClick={() => onEdit(index)}
                                    >
                                        <EditOutlinedIcon />
                                    </CustomIconButton>
                                </CustomTooltip>
                                <CustomTooltip arrow title={t('contact.remove')} placement={'bottom'}>
                                    <CustomIconButton aria-label="delete" onClick={onDelete} size="small">
                                        <DeleteOutlineOutlinedIcon />
                                    </CustomIconButton>
                                </CustomTooltip>
                            </Stack>

                            <Stack direction="column" spacing={1}>
                                {actor.email}
                            </Stack>
                        </Stack>
                    ))}
                </Stack>
            ) : null}

            {actors.length && !openForm ? addActor : null}

            {openForm ? (
                <Stack className={cx(flexBox.padding2, flexBox.borderRadius2, onlive.borderMediumGray)}>
                    <AppointmentFormActorForm
                        actor={actors[actorIdx]}
                        onSubmit={handleAddActorSubmit}
                        onCancel={onCancel}
                    />
                </Stack>
            ) : null}
            {actors.length === 0 && !openForm ? (
                <EmptyView
                    type={EmptyTypes.EMPTY_REASSIGN_AGENTS}
                    description={t('iCalendar.appointmentForm.emptyGuest')}
                    action={addActor}
                    className={flexBox.relative}
                />
            ) : null}
        </FormGroup>
    );
};

export default AppointmentFormActors;
